import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-choferes',
  templateUrl: './choferes.component.html',
  styleUrls: ['./choferes.component.scss']
})
export class ChoferesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
